(function () {

  const BUMPS = {
    gold:     { variantId: 45183678545974, price: 32.90,  originalPrice: 47.00,  entries: 4700,  label: 'Gold Quick Entry',     discount: '30%', multiplier: 143, freeEntries: 1410,  image: 'https://phantom4.co/cdn/shop/files/10.png?v=1771010878' },
    platinum: { variantId: 45183678709814, price: 67.90,  originalPrice: 97.00,  entries: 12125, label: 'Platinum Quick Entry', discount: '30%', multiplier: 179, freeEntries: 3638,  image: 'https://phantom4.co/cdn/shop/files/11.png?v=1771011641' },
    emerald:  { variantId: 45183678152758, price: 137.90, originalPrice: 197.00, entries: 29550, label: 'Emerald Quick Entry',  discount: '30%', multiplier: 214, freeEntries: 8865,  image: 'https://phantom4.co/cdn/shop/files/12.png?v=1771011943' },
    ruby:     { variantId: 45183678447670, price: 277.90, originalPrice: 397.00, entries: 79400, label: 'Ruby Quick Entry',     discount: '30%', multiplier: 286, freeEntries: 23820, image: 'https://phantom4.co/cdn/shop/files/13.png?v=1771012325' },
  };

  const BASE_ENTRIES = {
    gold: 4700, platinum: 12125, emerald: 29550, ruby: 79400
  };

  const TIER_ORDER = ['gold', 'platinum', 'emerald', 'ruby'];
  const ALL_BUMP_IDS = Object.values(BUMPS).map(b => b.variantId);
  const STORAGE_KEY = 'p4_last_cart';

  function isBumpItem(item) {
    return ALL_BUMP_IDS.includes(item.variant_id);
  }

  function getCartTier(items) {
    for (const item of items) {
      const t = (item.product_title || item.title || '').toLowerCase();
      if (t.includes('ruby'))     return 'ruby';
      if (t.includes('emerald'))  return 'emerald';
      if (t.includes('platinum')) return 'platinum';
      if (t.includes('gold'))     return 'gold';
    }
    return null;
  }

  function getBumpsToShow(tier) {
    if (!tier) return ['gold', 'platinum', 'emerald'];
    return TIER_ORDER.filter(t => t !== tier);
  }

  function getCheapest(keys) {
    return keys.reduce((a, b) => BUMPS[a].price < BUMPS[b].price ? a : b);
  }

  function reorderForMiddle(bumps, preChecked) {
    const others = bumps.filter(k => k !== preChecked);
    if (bumps.length === 3) return [others[0], preChecked, others[1]];
    return bumps;
  }

  function getBaseEntries(items) {
    let total = 0;
    for (const item of items) {
      if (isBumpItem(item)) continue;
      const t = (item.product_title || item.title || '').toLowerCase();
      if (t.includes('ruby'))          total += BASE_ENTRIES.ruby * item.quantity;
      else if (t.includes('emerald'))  total += BASE_ENTRIES.emerald * item.quantity;
      else if (t.includes('platinum')) total += BASE_ENTRIES.platinum * item.quantity;
      else if (t.includes('gold'))     total += BASE_ENTRIES.gold * item.quantity;
    }
    return total;
  }

  function saveCartSnapshot(cart) {
    const baseItems = cart.items.filter(i => !isBumpItem(i));
    if (baseItems.length === 0) return;
    const snapshot = cart.items.map(i => ({ id: i.variant_id, quantity: i.quantity, title: i.title }));
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot)); } catch(e) {}
  }

  function getSavedCart() {
    try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null'); } catch(e) { return null; }
  }

  async function fetchCart() {
    return (await fetch('/cart.js')).json();
  }

  async function addToCart(variantId, quantity = 1) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity }),
    });
  }

  async function removeFromCart(variantId) {
    const cart = await fetchCart();
    const item = cart.items.find(i => i.variant_id === variantId);
    if (!item) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: cart.items.indexOf(item) + 1, quantity: 0 }),
    });
  }

  async function removeAllBumpsFromCart() {
    let cart = await fetchCart();
    let bumpItem = cart.items.find(i => isBumpItem(i));
    while (bumpItem) {
      const idx = cart.items.indexOf(bumpItem) + 1;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: idx, quantity: 0 }),
      });
      cart = await fetchCart();
      bumpItem = cart.items.find(i => isBumpItem(i));
    }
  }

  async function refreshCartSection() {
    try {
      const res = await fetch('/?sections=main-cart-items');
      const data = await res.json();
      if (data['main-cart-items']) {
        const doc = new DOMParser().parseFromString(data['main-cart-items'], 'text/html');
        const newItems = doc.querySelector('#main-cart-items');
        const currentItems = document.querySelector('#main-cart-items');
        if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;
      }
      const cart = await fetchCart();
      const totalEl = document.querySelector('.totals__total-value');
      if (totalEl) {
        totalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + ' USD';
      }
      const countEl = document.querySelector('.cart-count-bubble span');
      if (countEl) countEl.textContent = cart.item_count;
    } catch(e) {
      console.log('Refresh error:', e);
    }
  }

  function showRestoreBanner() {
    const saved = getSavedCart();
    if (!saved || saved.length === 0) return;
    const baseItems = saved.filter(i => !ALL_BUMP_IDS.includes(i.id));
    const bumpItems = saved.filter(i => ALL_BUMP_IDS.includes(i.id));
    if (baseItems.length === 0) return;
    const existing = document.getElementById('p4-restore-banner');
    if (existing) return;

    const itemNames = baseItems.map(i => i.title).join(', ');
    const bumpNote = bumpItems.length > 0 ? ` + ${bumpItems.length} upgrade${bumpItems.length > 1 ? 's' : ''}` : '';

    const banner = document.createElement('div');
    banner.id = 'p4-restore-banner';
    banner.style.cssText = 'max-width:560px;margin:2rem auto;padding:20px 24px;border-radius:12px;border:1.5px solid #1D9E75;background:#f0fdf7;text-align:center;font-family:inherit;';
    banner.innerHTML = `
      <p style="font-size:15px;font-weight:600;color:#085041;margin:0 0 6px;">Did you mean to remove your order?</p>
      <p style="font-size:13px;color:#0F6E56;margin:0 0 16px;">${itemNames}${bumpNote}</p>
      <button id="p4-restore-btn" style="background:#1D9E75;color:#fff;border:none;border-radius:8px;padding:12px 28px;font-size:14px;font-weight:600;cursor:pointer;margin-bottom:8px;width:100%;max-width:280px;">Restore my order</button><br>
      <button id="p4-dismiss-btn" style="background:none;border:none;font-size:12px;color:#888;cursor:pointer;padding:6px;margin-top:4px;">No thanks, keep cart empty</button>
    `;

    const target = document.querySelector('#main-cart-items, main .page-width, main');
    if (target) target.insertAdjacentElement('afterbegin', banner);

    document.getElementById('p4-restore-btn').addEventListener('click', async () => {
      banner.innerHTML = '<p style="font-size:14px;color:#0F6E56;text-align:center;padding:8px 0;">Restoring your order...</p>';
      for (const item of saved) {
        await addToCart(item.id, item.quantity);
      }
      sessionStorage.removeItem(STORAGE_KEY);
      window.location.reload();
    });

    document.getElementById('p4-dismiss-btn').addEventListener('click', () => {
      sessionStorage.removeItem(STORAGE_KEY);
      banner.remove();
    });
  }

  let _state = {};
  let _bumps = [];
  let _preChecked = null;
  let _baseEntries = 0;
  let _container = null;
  let _busy = false;
  let _watcherInterval = null;

  function startCartWatcher() {
    if (_watcherInterval) clearInterval(_watcherInterval);
    _watcherInterval = setInterval(async () => {
      const cart = await fetchCart();
      const baseItems = cart.items.filter(i => !isBumpItem(i));
      if (baseItems.length === 0) {
        clearInterval(_watcherInterval);
        await removeAllBumpsFromCart();
        await refreshCartSection();
        if (_container) _container.style.display = 'none';
        showRestoreBanner();
      } else {
        saveCartSnapshot(cart);
      }
    }, 3000);
  }

  function render() {
    if (!_container) return;
    _container.innerHTML = `
      <div class="p4-bumps">
        <div class="p4-bumps__header">
          <p class="p4-bumps__eyebrow">Wait. Don't miss out</p>
          <p class="p4-bumps__subhead">Before you enter — make sure you have the HIGHEST chance of winning!</p>
        </div>
        <div class="p4-bumps__cards">
          ${_bumps.map((key, index) => {
            const b = BUMPS[key];
            const checked = _state[key];
            const isPopular = key === _preChecked;
            const isMidDesktop = index === 1;
            return `
              <div class="p4-bump-card${checked ? ' p4-bump-card--checked' : ''}${isMidDesktop ? ' p4-bump-card--featured' : ''}" data-key="${key}">
                ${isPopular ? '<div class="p4-bump-card__popular">Most Popular</div>' : ''}
                <div class="p4-bump-card__check${checked ? ' p4-bump-card__check--on' : ''}"></div>
                <img class="p4-bump-card__img" src="${b.image}" alt="${b.label}" />
                <div class="p4-bump-card__body">
                  <div class="p4-bump-card__name">${b.label}</div>
                  <div class="p4-bump-card__multiplier">NEW ${b.multiplier}x Multiplier</div>
                  <div class="p4-bump-card__free-entries">This one-time discount gives you <strong>${b.freeEntries.toLocaleString()} free entries</strong></div>
                  <div class="p4-bump-card__total-entries">Add this → <strong>${b.entries.toLocaleString()} Bonus Entries</strong></div>
                  <div class="p4-bump-card__pricing">
                    <span class="p4-bump-card__orig">$${b.originalPrice.toFixed(2)}</span>
                    <span class="p4-bump-card__disc">$${b.price.toFixed(2)}</span>
                    <span class="p4-bump-card__save">Save ${b.discount}</span>
                  </div>
                </div>
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;

    _container.querySelectorAll('.p4-bump-card').forEach(card => {
      card.addEventListener('click', () => {
        if (!_busy) handleToggle(card.dataset.key);
      });
    });
  }

  async function handleToggle(key) {
    _busy = true;
    const adding = !_state[key];
    _state[key] = adding;
    render();
    try {
      if (adding) {
        await addToCart(BUMPS[key].variantId);
      } else {
        await removeFromCart(BUMPS[key].variantId);
      }
      await refreshCartSection();
    } catch(e) {
      console.log('Toggle error:', e);
      _state[key] = !adding;
      render();
    }
    _busy = false;
  }

  async function init() {
    _container = document.getElementById('p4-cart-bumps');
    if (!_container) return;

    const cart = await fetchCart();
    const baseItems = cart.items.filter(i => !isBumpItem(i));

    if (baseItems.length === 0) {
      await removeAllBumpsFromCart();
      _container.style.display = 'none';
      showRestoreBanner();
      return;
    }

    saveCartSnapshot(cart);

    const cartBumpIds = cart.items.filter(i => isBumpItem(i)).map(i => i.variant_id);
    const tier = getCartTier(baseItems);
    const rawBumps = getBumpsToShow(tier);
    _baseEntries = getBaseEntries(baseItems);
    _preChecked = getCheapest(rawBumps);
    _bumps = reorderForMiddle(rawBumps, _preChecked);

    _bumps.forEach(k => {
      _state[k] = cartBumpIds.includes(BUMPS[k].variantId);
    });

    if (cartBumpIds.length === 0) {
      _state[_preChecked] = true;
      await addToCart(BUMPS[_preChecked].variantId);
      await refreshCartSection();
    }

    render();
    startCartWatcher();
  }

  document.addEventListener('DOMContentLoaded', init);

})();

// Remove bump products from recommendations
function removeBumpRecommendations() {
  document.querySelectorAll('h3.card__heading').forEach(function(heading) {
    if (heading.textContent.trim().includes('Off)')) {
      var card = heading.closest('li.grid__item') || heading.closest('li');
      if (card) card.remove();
    }
  });
}

// Run after delay to allow AJAX recommendations to load
setTimeout(removeBumpRecommendations, 3000);

// Also watch for any late loads
var observer = new MutationObserver(function() {
  removeBumpRecommendations();
});
observer.observe(document.body, { childList: true, subtree: true });